import axios from 'axios';
import { APP_CONFIG } from '../config/env';

export const apiClient = axios.create({
  baseURL: APP_CONFIG.apiBaseUrl,
  withCredentials: true,
});
